import { Checkbox, autofillDetectableStyle } from '@rbilabs/components-library';
import styled, { css } from 'styled-components';

import { theme } from 'styles/configure-theme';

interface IFormContainer {
  withPadding?: boolean;
  withBorder: boolean;
  isHidden?: boolean;
}

interface IPaycometItem {
  'aria-label'?: string;
  'data-testid'?: string;
  'data-paycomet'?: string;
}

export const FormContainer = styled.div<IFormContainer>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 1rem 0;
  background-color: transparent;
  font-size: 0.75rem;

  form {
    width: 100%;

    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
  }

  ${Styles.desktop`
    padding: ${({ withPadding }: IFormContainer) => (withPadding ? '1rem' : 0)};

    ${(p: IFormContainer) =>
      p.withBorder &&
      css`
        border: 1px solid ${Styles.color.grey.four};
        background-color: white;
      `}
    `}
`;

export const Form = styled.form<{ action?: string; noValidate?: boolean }>``;

export const StyledSaveCardContainer = styled.div`
  padding-bottom: 0.5rem;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 0 1rem;
`;

export const StyleFields = css`
  display: block;
  margin: 0;
  font: 14px;
  height: ${theme.token('height-input')};
  border-radius: ${p => p.theme.token('border-radius-input')};
  color: ${p => p.theme.token('text-default')};
  appearance: none;
  width: 100%;
  outline: 0;
  overflow: hidden;
  position: relative;

  ${autofillDetectableStyle};

  &:invalid {
    box-shadow: none;
  }

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
  }
`;

export const TextInput = styled.input`
  ${StyleFields}
  border: ${p => p.theme.token('border-default')};
  padding: ${p => p.theme.token('padding-input')};
`;

export const ErrorItem = styled.div<IPaycometItem>`
  margin: 0.5rem auto auto 0;
  color: ${p => p.theme.token('text-error')};
`;

/* BEGINNING OF THE STYLE TO PAYCOMET IFRAME */
export const PaycometSharedStyle = `
  display: block;
  margin: 0 0 0 -2px;
  font: 14px;
  height: 32px;
  border: none;
  color: ${theme.token('text-default')};
  appearance: none;
  width: 100%;
  outline: 0;
`;

export const CardNumberPaycometStyle = `
  ${PaycometSharedStyle}
  height: 32px;
`;

export const PaycometItem = styled.div<IPaycometItem>`
  display: flex;
`;

export const TextInputPaycomet = styled.input<IPaycometItem>``;

export const CardNumberPaycometContainer = styled.div`
  ${StyleFields}
  background: ${p => p.theme.token('background-input')};
  margin: 15px 0 0 0;
  display: flex;
  border: ${p => p.theme.token('border-default')};
  padding: ${p => p.theme.token('padding-input')};

  iframe {
    position: relative;
    height: 32px;
    margin: auto auto auto auto;
  }
`;

export const InfoPaycometContainer = styled.div`
  ${StyleFields}
  margin: 15px 0 0 0;
  display: flex;
`;

export const Expiry = styled.div`
  ${StyleFields}
  display: flex;
  position: relative;
  width: inherit;
  margin-right: 7.5px;

  input {
    ${StyleFields}
    border: ${p => p.theme.token('border-default')};
    padding: ${p => p.theme.token('padding-input')};
  }
`;

export const CvvField = styled.div`
  ${StyleFields}
  border: ${p => p.theme.token('border-default')};
  margin-left: 7.5px;
  padding: ${p => p.theme.token('padding-input')};
  background: ${p => p.theme.token('background-input')};

  iframe {
    position: relative;
    height: ${theme.token('height-input')};
    margin: auto auto auto auto;
  }
`;

export const CvvPaycometStyle = `
  ${PaycometSharedStyle}
  height: 43px;
`;

export const ZipCode = styled.div`
  ${StyleFields}
  display: flex;
  position: relative;
  margin: 15px 0 0 0;

  input {
    ${StyleFields}
    border: ${p => p.theme.token('border-default')};
    padding: ${p => p.theme.token('padding-input')};
  }
`;
/* FINAL OF THE STYLE TO PAYCOMET IFRAME */
